import { Box, Typography, Button, Stack } from "@mui/material";
import { ShieldX, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AccessDenied({ message }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 3,
      }}
    >
      <Stack spacing={3} alignItems="center" maxWidth={420} textAlign="center">
        <Box
          sx={{
            width: 110,
            height: 110,
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "rgba(255, 71, 87, 0.1)",
            boxShadow: "0 8px 20px rgba(255, 71, 87, 0.15)",
          }}
        >
          <ShieldX size={58} color="#FF4757" strokeWidth={1.5} />
        </Box>

        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            fontSize: { xs: 26, sm: 32 },
            letterSpacing: "-0.02em",
          }}
        >
          Access Denied
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ fontSize: 15, lineHeight: 1.6 }}
        >
          {"You do not have permission to view this page."}
        </Typography>

        <Button
          onClick={() => navigate(-1)}
          startIcon={<ArrowLeft size={18} />}
          variant="contained"
          sx={{
            mt: 1,
            textTransform: "none",
            fontWeight: 700,
            borderRadius: 2,
            px: 4,
            py: 1.2,
            background:
              "linear-gradient(90deg, #6a00f4 0%, #8e2de2 50%, #c86dd7 100%)",
            boxShadow: "0 8px 20px rgba(123,97,255,0.15)",
          }}
        >
          Go Back
        </Button>
      </Stack>
    </Box>
  );
}
